import { useCallback, useEffect, useState } from "react";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import Reactportal from "../../Reactportal/Reactportal";
import { SingleIssue } from "../../RequestSupportComponent/SingleIssue/SingleIssue";
import useKeyDown from "../AddLoad/text";
import "./AddAdminSupport.scss";
export const AddAdminRequestSupport = ({ show, TypeOfPortal, ParentPortalCloseFunction, fielddata }) => {
  const [toggle, settoggle] = useState(show ? show : false);

  // eslint-disable-next-line
  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
  };
  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);
  const HandleKeyDownf3 = useCallback(
    (event) => {
      if (event.keyCode === 27) {
        event.preventDefault();
        return Closeformfunction();
      }
    },
    [Closeformfunction]
  );
  useKeyDown(HandleKeyDownf3);
  return (
    <Reactportal
      id={""}
      open={toggle}
      onClose={Closeformfunction}
      TypeOfPortal={TypeOfPortal + " " + "Issue"}
      UserRightsPortal={false}
    >
      <div className="chatContainer">
        <SingleIssue settoggle={settoggle} TypeOfPortal={TypeOfPortal + " " + "Issue"} fielddata={fielddata} />
      </div>
    </Reactportal>
  );
};
